<template>
	<div class="c-file-list flex-wrap" :class="[`s-${size}`]" @click.stop>
		<c-file v-for="(image, i) in list" :key="i" :class="{'s-video': isVideo[i]}" :src="image" media :preview="list"></c-file>
	</div>
</template>

<script>
	export default {
		name: 'cFileList',
		
		props: {
			value: [String, Array],
			size: {
				type: String,
				default: 'normal'
			}
		},

		computed: {
			list() {
				return this.value ? typeof this.value == 'string' ? this.value.split(',') : this.value : [];
			},

			isVideo() {
				return this.list.map(item => {
					return this.parseFile(item).media == 'video';
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.c-file-list {
		gap: 6px;

		&.s-mini {
			>>> .c-file-media {
				width: 32px;
				height: 32px;
			}	
		}

		&.s-normal {
			>>> .c-file-media {
				width: 80px;
				height: 80px;
			}	
		}
	}
</style>
